<script >

    import {roundPrice} from '@/utils'

    import vue from 'vue'

    export default vue.extend({
        props: [ 'w', 'low','high','plow','phigh', 'last', 'fontsize'],
        inject: ['provider'],
        data(){
            return {
                x: 0, y:0,
                second_offset: 20,
                totalh: 50,
                barh: 10
            }
        },
        computed:{

            x1(){ return this.x + 50},
            y1(){ return this.y + this.fontsize + 3},
            x2(){ return this.x + 50},
            y2(){ return this.y + this.fontsize + this.second_offset + 6},

            //maxv(){ return Math.max(this.phigh,this.high) },
            //secondh(){ return Math.min(this.phigh,this.high) },
            //secondl(){ return Math.max(this.plow,this.low) },
            //minv(){ return Math.min(this.plow,this.low) },
            predictrange(){ return this.phigh - this.plow; },
            priorrange()  { return this.high - this.low; },
            predictscale(){ return (this.w)/(this.predictrange);},
            priorscale()  { return (this.w)/(this.priorrange);},

        },
        methods:{
            roundRect(ctx, x, y, width, height, radius, fill, stroke) {
                if (typeof stroke == 'undefined') {
                    stroke = true;
                }
                if (typeof radius === 'undefined') {
                    radius = 5;
                }
                if (typeof radius === 'number') {
                    radius = {tl: radius, tr: radius, br: radius, bl: radius};
                } else {
                    var defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
                    for (var side in defaultRadius) {
                        radius[side] = radius[side] || defaultRadius[side];
                    }
                }
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
                ctx.shadowBlur    = 2;
                ctx.shadowColor   = '#777';

                ctx.beginPath();
                ctx.moveTo(x + radius.tl, y);
                ctx.lineTo(x + width - radius.tr, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
                ctx.lineTo(x + width, y + height - radius.br);
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
                ctx.lineTo(x + radius.bl, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
                ctx.lineTo(x, y + radius.tl);
                ctx.quadraticCurveTo(x, y, x + radius.tl, y);
                ctx.closePath();
                if (fill) {
                    ctx.fill();
                }
                if (stroke) {
                    ctx.stroke();
                }

                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
                ctx.shadowBlur    = 0;
                ctx.shadowColor   = '#777';
            }
        },
        render(){

            if(!this.provider.context) return;
            const ctx = this.provider.context;

            ctx.clearRect(0, 0, this.x1 + this.w*2, this.y + this.totalh);

            ctx.strokeStyle = '#000';
            this.roundRect(ctx, this.x1, this.y1, this.w, this.barh,5, false);
            this.roundRect(ctx, this.x2 , this.y2, this.w, this.barh,5, false);




            var radius = this.barh/2;
            var ycenter = this.y1+this.barh/2;
            var xtv1 = (this.last - this.plow)*this.predictscale +  this.x1;


            if (xtv1 < this.x1 + this.w*2){
                ctx.fillStyle = '#090';
                ctx.beginPath();
                ctx.shadowBlur    = 1;
                /* ctx.ellipse ? ctx.ellipse(xtv1, ycenter, radius/1.5, radius,0,0,2 * Math.PI): 
                    ctx.rect(xtv1 - radius/1.5, ycenter - radius, radius/1.5*2, radius*2); */

                ctx.closePath();
                ctx.fill();
                ctx.shadowBlur    = 0;
                ctx.fillStyle = '#000'
                ctx.fillText( roundPrice(this.last),xtv1, this.y1-3);
            }


            var xtv2 = (this.last - this.low) * this.priorscale +  this.x2;
            if (xtv2 < this.x1 + this.w*2){
                ctx.fillStyle = '#090';
                ctx.moveTo(xtv2, ycenter);
                ctx.shadowBlur    = 1;
                ycenter = this.y2 + this.barh/2;
                /* ctx.ellipse ? ctx.ellipse(xtv2, ycenter, radius/1.5, radius,0,0,2 * Math.PI) : 
                    ctx.rect(xtv2 - radius/1.5, ycenter - radius, radius/1.5*2, radius*2); */


                ctx.fill();
                ctx.shadowBlur    = 0;
                ctx.fillStyle = '#000'
                ctx.fillText( roundPrice(this.last),xtv2, this.y2-3);
            }


            ctx.fillStyle = '#000'






            ctx.font = this.fontsize + 'px sans-serif';
            ctx.textAlign = 'center';


            ctx.lineWidth = 1;



            ctx.strokeStyle = '#000'
            ctx.lineWidth = 1;

            ctx.shadowOffsetY = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowBlur    = 0;


            var txt = roundPrice(this.plow);
            ctx.fillText(txt,this.x1-18, this.y1+this.fontsize);
            txt = roundPrice(this.phigh);
            ctx.fillText(txt,this.x1+this.w+18, this.y1+this.fontsize);

            txt = roundPrice(this.low);
            ctx.fillText(txt,this.x2-18, this.y2+this.fontsize);
            txt = roundPrice(this.high);
            ctx.fillText(txt,this.x2+this.w+18, this.y2+this.fontsize);

        }
    })
</script>
